import { Dialog, DialogTitle } from '@mui/material'
import React from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MyButton from '../form/MyButton';

const MyModalAgry = ({ open, setOpen, header, content, disableClickOutside, classNameAdd, setIsAgry, onlyOk, textNo, textYes }) => {
  return (
    <Dialog
        open={open}
        onClose={e => {
            if (!disableClickOutside) {
				setOpen(false)
			}
        }}
        aria-labelledby="responsive-dialog-title"
        className={classNameAdd ? `${classNameAdd} myModal` : 'myModal'}
    >
        <div className='myModal__headerBlock'>
            <p className='myModal__header'>
                { 
                    header 
                }
            </p>
            <div
                className='myModal__close'
                onClick={e => setOpen(false)}
            >
                <CloseRoundedIcon />
            </div>
        </div>
        <div className='myModal__content'>
            {
                content
            }
            <div className='myModal__content-buttons'>    
                {
                    onlyOk ?
                        <MyButton
                            autoFocus
                            onClick={(e) => {
                                e.preventDefault()
                                setOpen(false)
                            }}
                        >
                            {
                                textYes ? textYes : 'Підтвердити'
                            }
                        </MyButton>
                    :
                    <>
                        <MyButton
                            onClick={(e) => {
                                e.preventDefault()
                                if (setIsAgry) {
                                    setIsAgry(false)
                                }
                                setOpen(false)
                            }}
                            color='grey'
                        >
                            {
                                textNo ? textNo : 'Скасувати'
                            }
                        </MyButton>
                        <MyButton
                            autoFocus
                            onClick={(e) => {
                                e.preventDefault()
                                if (setIsAgry) {
                                    setIsAgry(true)
                                }
                                setOpen(false)
                            }}
                        >
                            {
                                textYes ? textYes : 'Підтвердити'
                            }
                        </MyButton>
                    </>
                }
            </div>
        </div>
    </Dialog>
  )
}

export default MyModalAgry